import { render, staticRenderFns } from "./add-comment.vue?vue&type=template&id=3ea1660d&scoped=true"
import script from "./add-comment.vue?vue&type=script&lang=js"
export * from "./add-comment.vue?vue&type=script&lang=js"
import style0 from "./add-comment.vue?vue&type=style&index=0&id=3ea1660d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1660d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea1660d')) {
      api.createRecord('3ea1660d', component.options)
    } else {
      api.reload('3ea1660d', component.options)
    }
    module.hot.accept("./add-comment.vue?vue&type=template&id=3ea1660d&scoped=true", function () {
      api.rerender('3ea1660d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/matter-logs/add-comment.vue"
export default component.exports